<template>
    <div class="devices-list__block" v-if="deviceData" @click="openChart">
        <device-status :device="deviceData" :showLocation="showLocation"/>
        <v-layout row class="devices-list__block__title">
            <device-title :device="deviceData"></device-title>
            <v-flex class="btn-block">
                <device-favorite :device="deviceData"></device-favorite>
            </v-flex>
        </v-layout>
        <div class="d-inline-flex align-center main-text mt-3" v-if="deviceData.state && deviceData.online">
            Освещённость:
            <span class="common-text font-weight-medium mx-1"> {{ deviceData.state.illuminance }} лк, </span>
            <v-img
                v-if="deviceData.state.illuminance < 21"
                max-height="22px"
                max-width="22px"
                :src="require('@/assets/icons/moon_icon.svg')"
                class="d-inline-flex"
            />
            <v-img
                v-else-if="deviceData.state.illuminance > 20 && deviceData.state.illuminance < 101"
                max-height="22px"
                max-width="22px"
                :src="require('@/assets/icons/cloudy_icon.svg')"
                class="d-inline-flex"
            />
            <v-img
                v-else-if="deviceData.state.illuminance > 101"
                max-height="22px"
                max-width="22px"
                :src="require('@/assets/icons/sun_icon.svg')"
                class="d-inline-flex"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: "IlluminationDevice",
    props: {
        device: {
            type: [Array, Object],
            default: null,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            deviceData: {},
        };
    },
    created() {
        this.deviceData = this.device;
    },
    watch: {
        device(val) {
            if (val) {
                this.deviceData = val;
            }
        },
    },
    methods: {
        openChart() {
            if (!this.deviceData.is_action) {
                this.$router.push({ name: 'lightingPage', query: {device: this.deviceData.uid}});
            }
        },
    },
}
</script>
